module.exports = __webpack_public_path__ + "static/media/CottonPatch.14cf5ce1.jpg";